import { Users } from "lucide-react";
import { TRY } from "@/lib/format";
import { cn } from "@/lib/utils";
import { Panel } from "@/components/Shared";

const initials = (n) => String(n || "?").trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toLocaleUpperCase("tr-TR");
export const roleLabel = (r) => (r === "admin" ? "Yönetici" : r === "worker" ? "Depo Müdürü" : "Personel");

// Yöneticiye: bugün kim kaç fiş kesti, ne kadar ciro yaptı (depo müdürü günlük satış özeti) — Z raporu by_user verisi
export function StaffTodayCard({ rows }) {
  const list = rows || [];
  const totalCount = list.reduce((a, u) => a + (u.count || 0), 0);
  return (
    <Panel title="Personel Satışları · Bugün" subtitle="Kullanıcı bazında fiş adedi ve ciro · iadeler düşülmüş" icon={Users} testid="qs-staff-today"
      actions={<span className="text-xs font-bold tnum rounded-full bg-muted px-2 py-0.5" data-testid="qs-staff-today-count">{list.length} kişi · {totalCount} fiş</span>}>
      {list.length === 0 ? (
        <p className="text-sm text-muted-foreground text-center py-4" data-testid="qs-staff-today-empty">Bugün henüz satış yok</p>
      ) : (
        <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-3">
          {list.map((u) => {
            const worker = u.role !== "admin";
            const key = u.user_id || "x";
            return (
              <div key={key} className={cn("rounded-2xl border p-4 flex items-start gap-3", worker ? "border-amber-200 bg-amber-50/40" : "border-slate-200 bg-card")} data-testid={`qs-staff-row-${key}`}>
                <div className={cn("grid h-10 w-10 place-items-center rounded-xl font-head font-black text-sm shrink-0 text-white", worker ? "bg-amber-500" : "bg-[#0B192C]")}>{initials(u.name)}</div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-1.5 flex-wrap">
                    <span className="font-bold text-sm truncate" data-testid={`qs-staff-name-${key}`}>{u.name}</span>
                    <span className={cn("rounded-full px-1.5 py-0.5 text-[9px] font-bold", worker ? "bg-amber-100 text-amber-800 border border-amber-200" : "bg-[#0B192C]/10 text-[#0B192C]")}>{roleLabel(u.role)}</span>
                  </div>
                  <div className="mt-2 flex items-end justify-between gap-2">
                    <div className="text-[11px] text-muted-foreground tnum"><b className="text-slate-700" data-testid={`qs-staff-count-${key}`}>{u.count}</b> fiş · ort. {TRY(u.count ? u.gross / u.count : 0)}</div>
                    <div className="font-head font-black tnum text-lg text-[#EA5820] leading-none" data-testid={`qs-staff-gross-${key}`}>{TRY(u.gross)}</div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Panel>
  );
}
